module.exports = __webpack_public_path__ + "static/media/pg.0b07d418.svg";